// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-page-recommendation {
  padding-top: 1rem;
  margin-bottom: 3rem;
}
.lsn-page-recommendation .lsn-request-header p {
  padding-top: 10px;
}
.lsn-page-recommendation .status-and-decline-wrapper {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: end;
}
.lsn-page-recommendation .status-and-decline-wrapper a {
  color: var(--main-red);
  font-size: 0.8rem;
}
.lsn-page-recommendation .evaluation-panel {
  padding: 0.75rem 0.45rem;
  background-color: var(--main-bg-color-darker);
  border-radius: var(--main-border-radius);
  border: var(--main-border-width) solid var(--main-border-color);
  flex-direction: row;
}
.lsn-page-recommendation .lsn-section-instructions {
  --bgColorComputed: color-mix(in srgb, var(--main-primary-color), 91% var(--main-white));
  --borderColorComputed: color-mix(in srgb, var(--main-primary-color), 20% var(--main-black));
  padding: 0.5rem 0.7rem;
  border: var(--main-border-width) solid var(--borderColorComputed) !important;
  border-radius: var(--main-border-radius);
  background-color: var(--bgColorComputed);
}
.lsn-page-recommendation .lsn-recommedation-note .lsn-header {
  margin-top: 30px;
  margin-bottom: 10px;
}
.lsn-page-recommendation .lsn-recommedation-note pre {
  background-color: var(--main-bg-color-lighter);
  border-left: 5px solid var(--main-border-color);
  font-style: italic;
  padding: 0.3rem 0.8rem;
  margin: 0;
  white-space: pre-wrap;
  font-family: 'ScalaSans', sans-serif !important;
}
.lsn-page-recommendation .lsn-question-block-container {
  margin-bottom: 30px !important;
  padding-left: 0rem !important;
  padding-right: 0rem !important;
}
.lsn-page-recommendation .lsn-question-container {
  padding-bottom: 15px !important;
}
.lsn-page-recommendation .general-indication-required-fileds {
  text-align: right;
  display: block;
  margin-block: 0.5rem;
}
.lsn-page-recommendation .evaluation-form {
  container: evaluation-form / inline-size;
  min-height: 50vh;
  padding: 0.5rem 0.7rem;
  border: var(--main-border-width) solid var(--main-border-color) !important;
  margin-bottom: 15px;
  border-radius: var(--main-border-radius) !important;
  background-color: var(--main-bg-color-lighter);
}
.lsn-page-recommendation .evaluation-form .level-3 {
  margin-bottom: 1rem;
}
.lsn-page-recommendation .lsn-message {
  text-align: center;
  margin-bottom: 1rem;
  font-size: 1.2rem;
  padding: 0.5rem;
}
.lsn-page-recommendation .lsn-decline-link {
  padding-top: 10px;
  line-height: 2.4rem;
}
.lsn-page-recommendation .lsn-form-buttons {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  column-gap: 20px;
  row-gap: 1rem;
}
.lsn-page-recommendation .lsn-form-buttons button {
  min-width: auto;
  flex-grow: 1;
  width: inherit;
}
@media (min-width: 990px) {
  .lsn-page-recommendation .lsn-form-buttons {
    flex-direction: row;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/recommendationForm/RecommendationForm.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,mBAAA;AACF;AAHA;EAMM,iBAAA;AAAN;AANA;EAWI,aAAA;EACA,+BAAA;EACA,gBAAA;AAFJ;AAXA;EAgBM,sBAAA;EACA,iBAAA;AAFN;AAfA;EAsBI,wBAAA;EACA,6CAAA;EACA,wCAAA;EACA,+DAAA;EACA,mBAAA;AAJJ;AAtBA;EA8BI,uFAAA;EACA,2FAAA;EACA,sBAAA;EACA,4EAAA;EACA,wCAAA;EACA,wCAAA;AALJ;AA9BA;EAwCM,gBAAA;EACA,mBAAA;AAPN;AAlCA;EA6CM,8CAAA;EACA,+CAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,qBAAA;EACA,+CAAA;AARN;AA3CA;EAwDI,8BAAA;EACA,6BAAA;EACA,8BAAA;AAVJ;AAhDA;EA8DI,+BAAA;AAXJ;AAnDA;EAkEI,iBAAA;EACA,cAAA;EACA,oBAAA;AAZJ;AAxDA;EAwEI,wCAAA;EACA,gBAAA;EACA,sBAAA;EACA,0EAAA;EACA,mBAAA;EACA,mDAAA;EACA,8CAAA;AAbJ;AAjEA;EAiFM,mBAAA;AAbN;AApEA;EAsFI,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAfJ;AA1EA;EA6FI,iBAAA;EACA,mBAAA;AAhBJ;AA9EA;EAkGI,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,gBAAA;EACA,aAAA;AAjBJ;AArFA;EAyGM,eAAA;EACA,YAAA;EACA,cAAA;AAjBN;AAqBE;EAAA;IAEI,mBAAA;EAnBJ;AACF","sourcesContent":[".lsn-page-recommendation {\n  padding-top: 1rem;\n  margin-bottom: 3rem;\n\n  .lsn-request-header {\n    p {\n      padding-top: 10px\n    }\n  }\n\n  .status-and-decline-wrapper {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    align-items: end;\n\n    a {\n      color: var(--main-red);\n      font-size: .8rem;\n    }\n  }\n\n  .evaluation-panel {\n    padding: .75rem .45rem;\n    background-color: var(--main-bg-color-darker);\n    border-radius: var(--main-border-radius);\n    border: var(--main-border-width) solid var(--main-border-color);\n    flex-direction: row;\n  }\n\n  .lsn-section-instructions {\n    --bgColorComputed: color-mix(in srgb, var(--main-primary-color), 91% var(--main-white));\n    --borderColorComputed: color-mix(in srgb, var(--main-primary-color), 20% var(--main-black));\n    padding: .5rem .7rem;\n    border: var(--main-border-width) solid var(--borderColorComputed) !important;\n    border-radius: var(--main-border-radius);\n    background-color: var(--bgColorComputed);\n  }\n\n  .lsn-recommedation-note {\n    .lsn-header {\n      margin-top: 30px;\n      margin-bottom: 10px;\n    }\n\n    pre {\n      background-color: var(--main-bg-color-lighter);\n      border-left: 5px solid var(--main-border-color);\n      font-style: italic;\n      padding: .3rem .8rem;\n      margin: 0;\n      white-space: pre-wrap;\n      font-family: 'ScalaSans', sans-serif !important;\n    }\n  }\n\n  .lsn-question-block-container {\n    margin-bottom: 30px !important;\n    padding-left: 0rem !important;\n    padding-right: 0rem !important;\n  }\n\n  .lsn-question-container {\n    padding-bottom: 15px !important;\n  }\n\n  .general-indication-required-fileds {\n    text-align: right;\n    display: block;\n    margin-block: .5rem;\n  }\n\n  .evaluation-form {\n    container: evaluation-form / inline-size;\n    min-height: 50vh;\n    padding: .5rem .7rem;\n    border: var(--main-border-width) solid var(--main-border-color) !important;\n    margin-bottom: 15px;\n    border-radius: var(--main-border-radius) !important;\n    background-color: var(--main-bg-color-lighter);\n\n    .level-3 {\n      margin-bottom: 1rem;\n    }\n  }\n\n  .lsn-message {\n    text-align: center;\n    margin-bottom: 1rem;\n    font-size: 1.2rem;\n    padding: .5rem;\n  }\n\n  .lsn-decline-link {\n    padding-top: 10px;\n    line-height: 2.4rem;\n  }\n\n  .lsn-form-buttons {\n    display: flex;\n    flex-direction: column;\n    justify-content: stretch;\n    column-gap: 20px;\n    row-gap: 1rem;\n\n    button {\n      min-width: auto;\n      flex-grow: 1;\n      width: inherit;\n    }\n  }\n\n  @media (min-width: 990px) {\n    .lsn-form-buttons {\n      flex-direction: row;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
